import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { Order } from 'app/shared/models';

@Injectable()
export class EnrollService {
  private enrolApiUrl = this.config.getConfig('apiUrl') + '/v1/Enrol';
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Authorization-ApiKey': this.config.getConfig('apiKey')
  });

  constructor(private http: HttpClient, private config: AppConfig) {}

  public create(order: Order): Promise<any> {
    console.log(JSON.stringify(order));
    return this.http
      .post(this.enrolApiUrl, JSON.stringify(order), { headers: this.headers })
      .toPromise()
      .catch(error => Promise.reject(error.message || error));
  }
}
